export default __webpack_public_path__ + "static/media/logo.6c0fe194.svg";